export var TopicType;

(function (TopicType) {
  TopicType["Event"] = "event";
  TopicType["MethodRequest"] = "command";
  TopicType["MethodResponse"] = "event";
})(TopicType || (TopicType = {}));

var createMessageTopic = function createMessageTopic(type) {
  return function (domain, serviceName, name) {
    var provider = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'wh';
    return "".concat(provider, ".").concat(domain, ".").concat(type, ".").concat(serviceName, ".").concat(name);
  };
};

export var getEventTopic = createMessageTopic(TopicType.Event);
export var getRequestTopic = createMessageTopic(TopicType.MethodRequest);
export var getResponseTopic = createMessageTopic(TopicType.MethodResponse);
//# sourceMappingURL=topic.js.map